import { SvgIcon, SxProps } from "@mui/material";
import SvgShareIcon from "jsx:../../../Images/Icons/FontAwesome/light/share-nodes.svg";

export function ShareIcon(props: SxProps) {
    return <SvgIcon component={SvgShareIcon} inheritViewBox sx={props} />;
}
